﻿export enum QuotationStatus {
    WaitingForApprove = 1,
    Followup = 2,
    Lost = 3,
    Win = 4,
    Revised = 5,
    Trashed = 6,
}